export default "__VITE_ASSET__57f0dc91__"